export const sortDepartments = (data) => {
    const result = [];

    if (data.length) {
        data.forEach((elem) => {
            const department = result.find((career) => career?.department?.id === elem?.department?.id);

            if (department?.careers) {
                department.careers.push(elem);
            } else {
                const newDepartment = {
                    department: {
                        id: elem?.department?.id,
                        name: elem?.department?.name,
                    },
                    careers: [elem],
                };

                result.push(newDepartment);
            }
        });

        result.sort((a, b) => a.department.name.localeCompare(b.department.name));
    }

    return result;
};
